import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const CK = process.env.REACT_APP_WC_CK;
const CS = process.env.REACT_APP_WC_CS;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const BRAND_API = "https://ecom.brightcodeapp.com/wp-json/wc/v3/products/brands";

const BrandOne = () => {
    const [brands, setBrands] = useState([]);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    

    useEffect(() => {

    fetch(`${BACKEND_URL}/api/brands/`)
    .then((res) => res.json())
    .then((data) => {
      if (data.status) setBrands(data.data);
      else {
        setBrands([]);
      }
    })
    .catch((err) => console.error("Brand API error:", err));

}, []);

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 8,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            { breakpoint: 1599, settings: { slidesToShow: 7 } },
            { breakpoint: 1399, settings: { slidesToShow: 6 } },
            { breakpoint: 992, settings: { slidesToShow: 5 } },
            { breakpoint: 575, settings: { slidesToShow: 4 } },
            { breakpoint: 424, settings: { slidesToShow: 3 } },
            { breakpoint: 359, settings: { slidesToShow: 2 } },
        ],
    };

    return (


        <>

        <style>
            {`

            /* Default (desktop) */
.brand-logo {
  width: 150px;
  height: 150px;
}

/* Tablet */
@media (max-width: 992px) {
  .brand-logo {
    width: 120px;
    height: 120px;
  }
}

/* Mobile */
@media (max-width: 575px) {
  .brand-logo {
    width: 90px;
    height: 90px;
  }
}

/* Small mobile */
@media (max-width: 424px) {
  .brand-logo {
    width: 70px;
    height: 70px;
  }
}

/* Extra small mobile */
@media (max-width: 359px) {
  .brand-logo {
    width: 60px;
    height: 60px;
  }
}
            
            
            
            `}
        </style>
        <div className="brand py-80">
            <div className="container container-lg">
                {/* style={{background:"#e3e3e1"}} */}
                <div className="brand-inner p-24 rounded-16 bg-white" >
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8 ">
                            <h5 className="mb-0">Shop by Brands</h5>
                            <div className="flex-align mr-point gap-16">
                                <Link
                                    to="/shop"
                                    className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                                >
                                    View All Deals
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="brand-slider arrow-style-two">
                        <Slider {...settings}>
                            {brands.map((brand) => (
                                <div className="brand-item d-flex justify-content-center align-items-center p-4" key={brand.id}>
                                    <img
                                        src={brand?.image?.src || "https://via.placeholder.com/150x80?text=Brand"}
                                        alt={brand.name}
                                        className="img-fluid brand-logo"
                                        style={{
                                            objectFit: "contain",
                                            borderRadius: "50%",
                                            padding: "2px",
                                            boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                            transition: "all 0.3s ease",
                                            cursor: "pointer"
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = "scale(1.08)";
                                            e.currentTarget.style.boxShadow = "0 10px 24px rgba(0,0,0,0.15)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = "scale(1)";
                                            e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.08)";
                                        }}
                                    />
                                </div>

                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default BrandOne;
